import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useAxios from "../../../../MainComponents/Hooks/useAxios.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import HelmetTags from "../../../../MainComponents/HelmetTags.jsx";

const AppUpdateSettings = () => {
  const [fetchState, setFetchState] = useState({
    flag: "getAppVersion",
    dependency: false,
    data: {},
  });
  const [submitState, setSubmitState] = useState({
    flag: "",
    dependency: false,
    data: {},
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      force_update: false,
      min_version: "1.0.0",
      android_store_url: "",
      ios_store_url: "",
      title_ar: "تحديث مطلوب",
      title_en: "Update Required",
      message_ar: "",
      message_en: "",
    },
  });

  const [getSuccess, , getLoading] = useAxios(
    process.env.REACT_APP_ADMIN_APP_VERSION_API,
    "GET",
    fetchState.flag,
    fetchState.dependency,
    fetchState.data,
    false
  );

  const [saveSuccess, saveErrors, saveLoading] = useAxios(
    process.env.REACT_APP_ADMIN_APP_VERSION_API,
    "POST",
    submitState.flag,
    submitState.dependency,
    submitState.data,
    true
  );

  useEffect(() => {
    if (!getSuccess?.data) return;
    const data = getSuccess.data;
    reset({
      force_update: !!data.force_update,
      min_version: data.min_version || "1.0.0",
      android_store_url: data.android_store_url || "",
      ios_store_url: data.ios_store_url || "",
      title_ar: data.title_ar || "تحديث مطلوب",
      title_en: data.title_en || "Update Required",
      message_ar: data.message_ar || "",
      message_en: data.message_en || "",
    });
  }, [getSuccess, reset]);

  useEffect(() => {
    if (saveSuccess) {
      setFetchState((prev) => ({
        ...prev,
        dependency: !prev.dependency,
      }));
    }
  }, [saveSuccess]);

  const onSubmit = (data) => {
    setSubmitState({
      flag: "saveAppVersion",
      dependency: !submitState.dependency,
      data: {
        ...data,
        force_update: data.force_update === true || data.force_update === "true" || data.force_update === 1 || data.force_update === "1",
      },
    });
  };

  return (
    <section className="dark:bg-dark dark:text-light h-full w-full overflow-y-auto px-10 py-10 sm:px-4">
      <HelmetTags title={"App Update | Mr.Mohamed Salama"} />
      <h2 className="mb-3 text-start text-2xl font-bold sm:text-center">
        App Update Settings
      </h2>
      <p className="mb-10 text-slate-500 dark:text-slate-400 sm:text-center">
        تحكم في ظهور بوب أب إجبار تحديث تطبيق ولي الأمر
      </p>

      <div className="flex w-full items-start justify-center">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="admin-content-form flex h-fit w-full max-w-2xl flex-col items-stretch gap-5 rounded-3xl bg-white p-8 shadow-md"
        >
          {getLoading && !getSuccess ? (
            <div className="flex justify-center py-10">
              <FontAwesomeIcon icon={faSpinner} spin className="text-2xl" />
            </div>
          ) : (
            <>
              <label className="admin-content-form__check flex items-center gap-3 rounded-xl border border-slate-200 p-4">
                <input
                  type="checkbox"
                  className="h-5 w-5"
                  {...register("force_update")}
                />
                <span className="font-semibold">
                  تفعيل التحديث الإجباري (Force Update)
                </span>
              </label>

              <div className="flex flex-col gap-2">
                <label className="font-semibold">أقل إصدار مسموح (min version)</label>
                <input
                  className="signin-inputs w-full pl-4"
                  placeholder="مثلاً 1.0.2"
                  {...register("min_version", {
                    required: true,
                    pattern: /^\d+(\.\d+)*$/,
                  })}
                />
                {errors.min_version && (
                  <p className="text-sm text-red-500">
                    اكتب رقم إصدار صحيح مثل 1.0.2
                  </p>
                )}
                <p className="admin-content-form__hint text-sm text-slate-500">
                  لو Force Update مفعّل والإصدار عند المستخدم أقل من الرقم ده،
                  هيظهر بوب أب ومايقدرش يدخل التطبيق.
                </p>
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold">رابط Google Play</label>
                <input
                  className="signin-inputs w-full pl-4"
                  {...register("android_store_url")}
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold">رابط App Store</label>
                <input
                  className="signin-inputs w-full pl-4"
                  {...register("ios_store_url")}
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold">عنوان البوب أب (عربي)</label>
                <input
                  className="signin-inputs w-full pl-4"
                  {...register("title_ar", { required: true })}
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold">رسالة البوب أب (عربي)</label>
                <textarea
                  rows={4}
                  className="signin-inputs w-full pl-4 pt-3"
                  {...register("message_ar", { required: true })}
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold">Title (English)</label>
                <input
                  className="signin-inputs w-full pl-4"
                  {...register("title_en")}
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold">Message (English)</label>
                <textarea
                  rows={3}
                  className="signin-inputs w-full pl-4 pt-3"
                  {...register("message_en")}
                />
              </div>

              {saveErrors?.response?.data?.errors && (
                <div className="admin-content-form__errors rounded-lg bg-red-50 p-3 text-sm text-red-600">
                  {Object.values(saveErrors.response.data.errors)
                    .flat()
                    .map((msg, i) => (
                      <p key={i}>{msg}</p>
                    ))}
                </div>
              )}

              <button
                type="submit"
                disabled={saveLoading && submitState.flag}
                className="submit mt-2 w-full"
              >
                {saveLoading && submitState.flag ? (
                  <FontAwesomeIcon icon={faSpinner} spin />
                ) : (
                  "حفظ الإعدادات"
                )}
              </button>
            </>
          )}
        </form>
      </div>
    </section>
  );
};

export default AppUpdateSettings;
